__turbopack_context__.v({
  "accordion-entry-animation": "AccordionTerrace-module-scss-module__huOqkG__accordion-entry-animation",
  "accordionBlockWrapper": "AccordionTerrace-module-scss-module__huOqkG__accordionBlockWrapper",
  "accordionItem": "AccordionTerrace-module-scss-module__huOqkG__accordionItem",
  "accordionItemContent": "AccordionTerrace-module-scss-module__huOqkG__accordionItemContent",
  "accordionItemSubItem": "AccordionTerrace-module-scss-module__huOqkG__accordionItemSubItem",
  "accordionItemTitle": "AccordionTerrace-module-scss-module__huOqkG__accordionItemTitle",
  "accordionList": "AccordionTerrace-module-scss-module__huOqkG__accordionList",
  "accordionSearchContainer": "AccordionTerrace-module-scss-module__huOqkG__accordionSearchContainer",
  "accordionSearchHeader": "AccordionTerrace-module-scss-module__huOqkG__accordionSearchHeader",
  "accordionSearchLoading": "AccordionTerrace-module-scss-module__huOqkG__accordionSearchLoading",
  "accordionSearchResult": "AccordionTerrace-module-scss-module__huOqkG__accordionSearchResult",
  "blocksBackgroundColor": "AccordionTerrace-module-scss-module__huOqkG__blocksBackgroundColor",
  "blocksFontColor": "AccordionTerrace-module-scss-module__huOqkG__blocksFontColor",
  "breadcrumbs": "AccordionTerrace-module-scss-module__huOqkG__breadcrumbs",
  "closeButton": "AccordionTerrace-module-scss-module__huOqkG__closeButton",
  "closed": "AccordionTerrace-module-scss-module__huOqkG__closed",
  "container": "AccordionTerrace-module-scss-module__huOqkG__container",
  "content": "AccordionTerrace-module-scss-module__huOqkG__content",
  "controlButton": "AccordionTerrace-module-scss-module__huOqkG__controlButton",
  "deleteButton": "AccordionTerrace-module-scss-module__huOqkG__deleteButton",
  "docmersionText": "AccordionTerrace-module-scss-module__huOqkG__docmersionText",
  "editItemButton": "AccordionTerrace-module-scss-module__huOqkG__editItemButton",
  "editorButton": "AccordionTerrace-module-scss-module__huOqkG__editorButton",
  "editorButtons": "AccordionTerrace-module-scss-module__huOqkG__editorButtons",
  "expandAllButtonContainer": "AccordionTerrace-module-scss-module__huOqkG__expandAllButtonContainer",
  "expandCollapseButton": "AccordionTerrace-module-scss-module__huOqkG__expandCollapseButton",
  "form-control": "AccordionTerrace-module-scss-module__huOqkG__form-control",
  "fullWidthButton": "AccordionTerrace-module-scss-module__huOqkG__fullWidthButton",
  "goBackButton": "AccordionTerrace-module-scss-module__huOqkG__goBackButton",
  "goBackWrapper": "AccordionTerrace-module-scss-module__huOqkG__goBackWrapper",
  "icon": "AccordionTerrace-module-scss-module__huOqkG__icon",
  "markdownEditor": "AccordionTerrace-module-scss-module__huOqkG__markdownEditor",
  "markdownEditorContent": "AccordionTerrace-module-scss-module__huOqkG__markdownEditorContent",
  "messageContainer": "AccordionTerrace-module-scss-module__huOqkG__messageContainer",
  "open": "AccordionTerrace-module-scss-module__huOqkG__open",
  "reorder": "AccordionTerrace-module-scss-module__huOqkG__reorder",
  "reorderActive": "AccordionTerrace-module-scss-module__huOqkG__reorderActive",
  "rotated": "AccordionTerrace-module-scss-module__huOqkG__rotated",
  "saveButton": "AccordionTerrace-module-scss-module__huOqkG__saveButton",
  "searchAndButtonContainer": "AccordionTerrace-module-scss-module__huOqkG__searchAndButtonContainer",
  "searchAndExpandButtonContainer": "AccordionTerrace-module-scss-module__huOqkG__searchAndExpandButtonContainer",
  "searchBoxContainer": "AccordionTerrace-module-scss-module__huOqkG__searchBoxContainer",
  "searchResultsTitle": "AccordionTerrace-module-scss-module__huOqkG__searchResultsTitle",
  "secondaryNavBackgroundColor": "AccordionTerrace-module-scss-module__huOqkG__secondaryNavBackgroundColor",
  "subItemEditor": "AccordionTerrace-module-scss-module__huOqkG__subItemEditor",
  "themeBackgroundColor": "AccordionTerrace-module-scss-module__huOqkG__themeBackgroundColor",
  "themeFontColor": "AccordionTerrace-module-scss-module__huOqkG__themeFontColor",
  "tooltip": "AccordionTerrace-module-scss-module__huOqkG__tooltip",
  "viewMoreButton": "AccordionTerrace-module-scss-module__huOqkG__viewMoreButton",
});
